import { gql } from "@/__generated__/gql";

export const COMMIT_INDEX_SUMMARY = gql(`
query commitIndexSummary($orgId: ID!, $cohortYear:Int!) {
  node(id: $orgId) {
    id
    ... on Organization {
      commitIndexSummary(cohortYear: $cohortYear) {
        low {
          state
          value
        }
        medium {
          state
          value
        }
        high {
          state
          value
        }
      }
    }
  }
}
`);
